import { render, staticRenderFns } from "./RevenueRecord.vue?vue&type=template&id=772b0ce1&scoped=true&"
import script from "./RevenueRecord.vue?vue&type=script&lang=js&"
export * from "./RevenueRecord.vue?vue&type=script&lang=js&"
import style0 from "./RevenueRecord.vue?vue&type=style&index=0&id=772b0ce1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772b0ce1",
  null
  
)

export default component.exports